import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty, filter, get } from 'lodash';
import { useMediaQuery } from 'react-responsive/src';
import { RouteNames } from 'router';
import PageTemplate from 'components/templates/pageTemplate';
import DiningDetailsBanner from 'components/organisms/diningDetailsBanner';
import VisionPhilosophySection from 'components/templates/vision&PhilosophySection';
import CraftBeerSection from 'components/templates/craftBeerAndBrewery';
import FooterSection from 'components/templates/footer';
import { PageLoader } from 'components/molecules/pageLoader';
import { HomeActions } from 'modules/home/actions';
import { HomeSelector } from 'modules/home/selector';
import { CmsPagesActions } from 'modules/cmsPages/actions';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
import { EventSelector } from 'modules/event/selector';
import { EventActions } from 'modules/event/actions';
import { DiningMenuSection } from 'components/templates/diningMenuSection';
import { ContactUsSection } from 'components/templates/contactUsSection';
import { RestaurantSelector } from 'modules/restaurant/selector';
import { RestaurantActions } from 'modules/restaurant/actions';
import ImageGallerySection from 'components/templates/imageGallerySection';
import { NavigationUtil } from 'utils/NavigationUtil';
import UpcomingShowsSection from 'components/templates/upcomingShowsSection';
import SisterRestaurants from 'components/templates/sisterRestaurants';
import { ShareModal } from 'components/templates/shareModal';
import BeerExplorer from 'components/organisms/beerExplorer';
import Team from 'components/templates/team';
import { TeamActions } from 'modules/team/action';
import { TeamSelector } from 'modules/team/selector';
import MusicFoundation from 'components/templates/musicFoundation';
import RestaurantHeaderButtons from 'components/atoms/restaurantHeaderButtons';
import RenderSEO from 'components/atoms/renderSEO';
import { FooterSelector } from 'modules/footerLink/selector';
import { FooterActions } from 'modules/footerLink/actions';

const DiningDetails = props => {
  const {
    isLoading,
    getVerticals,
    verticals,
    verticalId,
    getContactDetails,
    contact,
    getSiteSettings,
    siteSettings,
    footerLink,
    getFooterLinkData,
    getPageData,
    foundationData,
    craftBeerSectionData,
    visionPhilosophySection,
    getMenuCategories,
    restaurantCategories,
    getGalleryForRestaurant,
    gallery,
    banner,
    getBannerDetails,
    getUpcomingEvents,
    upcomingShows,
    getAllRestaurants,
    sisterRestaurantsData,
    getBeers,
    beerData,
    upcomingShowsOverlayData,
    teamData,
    getTeamData,
    getBannerData,
  } = props;
  const isMobile = useMediaQuery({ query: '(max-device-width: 560px)' });
  const restaurant_url_slug = props.match.params.restaurantSlug;
  const defaultOutletSlug = props.match.params.outletSlug;
  const restaurantName = isEmpty(banner) ? '' : get(banner[0], 'name', '');
  const outlet_id = isEmpty(banner) ? '' : get(banner[0], 'outlet_id', '');
  let [theme, setTheme] = useState(isMobile ? 'dark-theme' : 'light-theme');
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  useEffect(() => {
    getContactDetails();
    getVerticals();
    getSiteSettings();
    getPageData();
    getBannerData();
    getMenuCategories(restaurant_url_slug);
    getGalleryForRestaurant(restaurant_url_slug);
    getBannerDetails(restaurant_url_slug);
    getUpcomingEvents();
    getAllRestaurants();
    getFooterLinkData();
    getBeers(defaultOutletSlug);
    getTeamData(verticalId, restaurant_url_slug);
  }, []);

  useEffect(() => {
    getBannerDetails(restaurant_url_slug);
    getMenuCategories(restaurant_url_slug);
    getGalleryForRestaurant(restaurant_url_slug);
  }, [restaurant_url_slug]);

  const hasData = () => {
    return (
      banner &&
      gallery &&
      siteSettings &&
      verticals &&
      restaurantCategories &&
      visionPhilosophySection &&
      contact &&
      foundationData &&
      craftBeerSectionData &&
      sisterRestaurantsData &&
      beerData &&
      teamData &&
      footerLink
    );
  };

  if (isLoading) {
    return <PageLoader isMobile={isMobile} />;
  }
  if (!hasData()) {
    return null;
  }

  let metaTagSEO = {};
  banner.filter(tag => {
    if (tag.outletSlug === props.match.params.outletSlug) {
      metaTagSEO = tag.metaTagSEO;
    }
    return metaTagSEO;
  });

  let filteredGallery = filter(
    gallery,
    extractedData => extractedData.outlet_id === outlet_id
  );

  contact.title = `Come Visit ${restaurantName}`;

  const closeShareModal = () => {
    setIsShareModalOpen(false);
  };

  const componentList = [
    ...(!isEmpty(banner)
      ? [
          {
            component: DiningDetailsBanner,
            data: {
              banner,
              restaurantCategories,
            },
            theme: isMobile ? 'dark-theme' : 'light-theme',
            sectionId: 'banner',
            breadcrumbList: [
              {
                breadcrumbName: !isMobile ? 'TotalEnvironment' : restaurantName,
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: restaurantName,
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(restaurantCategories) && !isEmpty(restaurantName)
      ? [
          {
            component: DiningMenuSection,
            data: {
              banner,
              restaurantCategories,
              restaurantName,
            },
            theme: isMobile ? 'dark-theme' : 'light-theme',
            sectionId: 'menu',
            breadcrumbList: [
              {
                breadcrumbName: !isMobile ? 'TotalEnvironment' : restaurantName,
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: restaurantName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Menu',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(filteredGallery)
      ? [
          {
            component: ImageGallerySection,
            data: {
              images: filteredGallery,
            },
            theme: 'dark-theme',
            sectionId: 'gallery',
            breadcrumbList: [
              {
                breadcrumbName: !isMobile ? 'TotalEnvironment' : restaurantName,
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: restaurantName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Gallery',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(visionPhilosophySection.visionSection)
      ? [
          {
            component: VisionPhilosophySection,
            data: {
              banner,
              visionPhilosophySection,
              showButton: false,
              showCount: true,
              type: 'restaurant',
            },
            theme: 'light-theme',
            sectionId: 'vision-and-philosophy',
            breadcrumbList: [
              {
                breadcrumbName: !isMobile ? 'TotalEnvironment' : restaurantName,
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: restaurantName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Vision & Philosophy',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(craftBeerSectionData)
      ? [
          {
            component: CraftBeerSection,
            data: {
              banner,
              craftBeerSectionData,
              showButton: true,
              restaurantButtons: true,
              showGetInTouch: false,
              showCallToActionButton: false,
              showLineUpButton: true,
              beerData,
              noPadding: true,
            },
            theme: 'light-theme',
            sectionId: 'brewery',
            breadcrumbList: [
              {
                breadcrumbName: !isMobile ? 'TotalEnvironment' : restaurantName,
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: restaurantName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Craft Beer & Brewery',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(beerData)
      ? [
          {
            component: BeerExplorer,
            data: { beerData },
            theme: 'light-theme',
            sectionId: 'beer-explorer',
            breadcrumbList: [
              {
                breadcrumbName: !isMobile ? 'TotalEnvironment' : restaurantName,
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: restaurantName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Beer Explorer',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(teamData)
      ? [
          {
            component: Team,
            sectionId: 'team',
            breadcrumbList: [
              {
                breadcrumbName: !isMobile ? 'TotalEnvironment' : restaurantName,
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: restaurantName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'The Team',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            data: teamData,
          },
        ]
      : []),
    ...(!isEmpty(foundationData)
      ? [
          {
            component: MusicFoundation,
            data: {
              foundationData,
              cmsDetailsData: [],
              show_desktop_overlay_button: false,
              type: 'restaurant',
            },
            theme: 'light-theme',
            sectionId: 'foundation',
            breadcrumbList: [
              {
                breadcrumbName: !isMobile ? 'TotalEnvironment' : restaurantName,
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: restaurantName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Music Foundation',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(upcomingShows)
      ? [
          {
            component: UpcomingShowsSection,
            data: { upcomingShows, upcomingShowsOverlayData },
            theme: 'dark-theme',
            sectionId: 'upcoming-shows',
            breadcrumbList: [
              {
                breadcrumbName: !isMobile ? 'TotalEnvironment' : restaurantName,
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: restaurantName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Music & Concerts',
                breadcrumbLink: '#',
              },
            ],
          },
        ]
      : []),
    ...(!isEmpty(sisterRestaurantsData)
      ? [
          {
            component: SisterRestaurants,
            sectionId: 'sister-restaurants',
            breadcrumbList: [
              {
                breadcrumbName: !isMobile ? 'TotalEnvironment' : restaurantName,
                breadcrumbLink: RouteNames.landing,
              },
              {
                breadcrumbName: restaurantName,
                breadcrumbLink: '#',
              },
              {
                breadcrumbName: 'Sister Restaurant',
                breadcrumbLink: '#',
              },
            ],
            theme: 'dark-theme',
            data: { data: sisterRestaurantsData },
          },
        ]
      : []),
    {
      component: ContactUsSection,
      data: { contact, verticals, verticalId },
      location: props,
      sectionId: 'contact',
      breadcrumbList: [
        {
          breadcrumbName: !isMobile ? 'TotalEnvironment' : restaurantName,
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: restaurantName,
          breadcrumbLink: '#',
        },
        {
          breadcrumbName: 'Contact Us',
          breadcrumbLink: '#',
        },
      ],
      theme: 'light-theme',
    },
    {
      component: FooterSection,
      theme: 'dark-theme',
      sectionId: 'te-links',
      breadcrumbList: [
        {
          breadcrumbName: !isMobile ? 'TotalEnvironment' : restaurantName,
          breadcrumbLink: RouteNames.landing,
        },
        {
          breadcrumbName: restaurantName,
          breadcrumbLink: '#',
        },
        {
          breadcrumbName: 'Link',
          breadcrumbLink: '#',
        },
      ],
      data: { siteSettings, footerLink },
    },
  ];

  // TODO: refactor
  const merchandise = banner.filter(link => {
    if (link.outletSlug === props.match.params.outletSlug) {
      return link.merchandiseLink;
    }
  });

  const order = banner.filter(link => {
    if (link.outletSlug === props.match.params.outletSlug) {
      return link.orderOnlineLink;
    }
  });

  const reservation = banner.filter(link => {
    if (link.outletSlug === props.match.params.outletSlug) {
      return link.reservationLink;
    }
  });

  const joinLink = teamData.length > 0 ? teamData[0].join_team_link : null;
  const reservationFormData = { banner, contact, verticals, verticalId };
  return (
    <div>
      <RenderSEO
        metaTags={metaTagSEO}
        currentRouteName={`${restaurant_url_slug}/${defaultOutletSlug}`}
      />
      <PageTemplate
        theme={theme}
        componentList={componentList}
        updateTheme={e => setTheme(e)}
        verticals={verticals}
        siteSettings={siteSettings}
        showGetInTouch={false}
        textDecoration={false}
        toggleHeaderItem={true}
        type={'restaurant'}
        headerButtons={
          <RestaurantHeaderButtons
            restaurantCategories={restaurantCategories}
            craftBeerSectionData={craftBeerSectionData}
            upcomingShows={foundationData}
            merchandiseLink={merchandise}
            reservationLink={reservation}
            teamData={teamData}
            joinLink={joinLink}
            orderLink={order}
            restaurantName={restaurantName}
            location={props}
            data={reservationFormData}
          />
        }
      />
      <ShareModal isOpen={isShareModalOpen} onClosePress={closeShareModal} />
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const verticalKey = NavigationUtil.getVerticalKeyForLocation(props.location);
  const defaultOutletSlug = props.match.params.outletSlug;
  return {
    isLoading:
      RestaurantSelector.isRestaurantDetailsPageLoading(state) ||
      CmsPagesSelector.isCmsPageLoading(state) ||
      HomeSelector.isLoading(state) ||
      FooterSelector.isLoading(state) ||
      EventSelector.getUpcomingEventsLoading(state) ||
      TeamSelector.getTeamLoading(state) ||
      RestaurantSelector.getBeerLoading(state),
    footerLink: FooterSelector.getFooterData(state),
    craftBeerSectionData: CmsPagesSelector.getCmsPages(
      state,
      'Craft Beer & Brewery',
      true
    ),
    gallery: RestaurantSelector.getGallery(state),
    foundationData: CmsPagesSelector.getMusicFoundation(
      state,
      'Music Foundation',
      'restaurants',
      true
    ),
    contact: HomeSelector.getContactForVertical(state, verticalKey),
    verticalId: HomeSelector.getVerticalIdForKey(verticalKey),
    siteSettings: HomeSelector.getSiteSettings(state),
    verticals: HomeSelector.getVerticals(state),
    restaurantCategories: RestaurantSelector.getMenuCategories(state),
    visionPhilosophySection: CmsPagesSelector.getVisionPhilosophy(
      state,
      '',
      'restaurants',
      true
    ),
    banner: RestaurantSelector.getBanner(state),
    upcomingShows: EventSelector.getUpcomingEvents(state),
    sisterRestaurantsData: RestaurantSelector.getSisterRestaurantsData(
      state,
      defaultOutletSlug
    ),
    beerData: RestaurantSelector.getBeer(state),
    upcomingShowsOverlayData: EventSelector.getUpcomingEventsOverlayData(state),
    teamData: TeamSelector.getTeamData(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { getTeamData } = TeamActions;
  const { getPageData } = CmsPagesActions;
  const { getUpcomingEvents } = EventActions;
  const {
    getBannerData,
    getContactDetails,
    getVerticals,
    getSiteSettings,
  } = HomeActions;
  const { getFooterLinkData } = FooterActions;
  const {
    getMenuCategories,
    getGalleryForRestaurant,
    getBannerDetails,
    getAllRestaurants,
    getBeers,
  } = RestaurantActions;
  return bindActionCreators(
    {
      getGalleryForRestaurant,
      getContactDetails,
      getSiteSettings,
      getVerticals,
      getMenuCategories,
      getPageData,
      getBannerDetails,
      getUpcomingEvents,
      getAllRestaurants,
      getBeers,
      getTeamData,
      getFooterLinkData,
      getBannerData,
    },
    dispatch
  );
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DiningDetails)
);
